let cartBtn = document.querySelector('#cart-btn');
let cartWrap = document.querySelector('#side-cart-wrap');

cartBtn.addEventListener('click', function(event){
  event.preventDefault();
  //console.log("Open Cart");
  cartWrap.classList.add('open');
});

let mobilecartBtn = document.querySelector('#carto-sign');

mobilecartBtn.addEventListener('click', function(event){
  event.preventDefault();
  //console.log("Open Cart");
  cartWrap.classList.toggle('open');
});

let closemobilecartBtn = document.querySelector('#carto-btn');
closemobilecartBtn.addEventListener('click', function(event){
  event.preventDefault();
  //console.log("Open Cart");
  cartWrap.classList.toggle('open');
});

let conShopping = document.querySelector(".continue-btn");
conShopping.addEventListener('click', function(event){
  event.preventDefault();
  cartWrap.classList.remove("open");
});

//About
// let aboutBtn = document.querySelector('#about-btn a');
// let aboutBlock = document.querySelector('#about-block');

// let contactSection = document.querySelector('#contact-mobile-section');

// aboutBtn.addEventListener('click', function(event){
//   event.preventDefault();
//   this.parentNode.classList.toggle('active');
//   aboutBlock.classList.toggle('active');
//   contactSection.classList.toggle('hide');
// });

let aboutBtn = document.querySelector('#about-btn');
let aboutPop = document.querySelector('#pop-about');
let closeAbout = aboutPop.querySelector('.close-btn');

aboutBtn.addEventListener('click', function(event){
  event.preventDefault();
  aboutPop.classList.toggle('open');
});

closeAbout.addEventListener("click", function (event) {
  event.preventDefault();
  aboutPop.classList.toggle("open");
});

//Mobile Nav Btn
let navBtn = document.querySelector("#nav-btn");
if(navBtn){
  navBtn.addEventListener("click", function (e) {
    e.preventDefault();
    this.classList.toggle("open");
    //document.querySelector("body").classList.toggle("no-scroll");
    document.querySelector("#mobile-nav").classList.toggle("open");
    //document.querySelector("#mobile-nav-wrap").classList.toggle("animate");
  });
}

//Mobile Newsletter Button
// let mobileNewsBtn = document.querySelector('.mobile-newsletter-btn');

// mobileNewsBtn.addEventListener('click', function(event){
//   event.preventDefault();
//   document.querySelector("#mobile-nav").classList.remove("open");
//   window.scrollTo(0, document.body.scrollHeight);
// });

//Cart
$(document).on("cart.requestComplete", function(event, cart) {
  // var cartCount = cart.item_count;
  // var cartAmount = cart.total_price;
  // var success = $(".feedback .success");

  // $("#cart-count").html(cartCount);
  // $("#cart-amount").html(cartAmount / 100);
  // success.addClass("appear");
  $('#side-cart-wrap').addClass('open');
});

window.onscroll = function() {
  stickyHeader();
};

function stickyHeader() {
  let fixedHeader = document.querySelector("header");
  let mobileSticky = document.querySelector("#mobile-nav-wrap");
  if (document.body.scrollTop > 30 || document.documentElement.scrollTop > 30) {
    fixedHeader.classList.add("sticky");
    //mobileSticky.classList.add("top-off");
  } else {
    fixedHeader.classList.remove("sticky");
    //mobileSticky.classList.remove("top-off");
  }
}

$(document).on("cart.ready", function (event, cart) {
  var cartCount = cart.item_count;
  var cartInteger = parseInt(cartCount);
  if (cartInteger == 0) {
    // $("#carto-sign").removeClass("cart-not-empty");
    $(".cart-btno").addClass("hide");

    $("#side-checkout").addClass("cart-empty");
    $(".mobile-shipping").addClass("cart-empty");
    $(".cart-con .bar").addClass("cart-empty");
  }
});



$(document).on('cart.requestComplete', function(event, cart) {

  if(cart.item_count == 1){
    $("#x-counter").html(cart.item_count + ' item');
  } else {
    $("#x-counter").html(cart.item_count + ' items');
  }

  
  $('#mx-counter').html(cart.item_count);

  var cartCount = cart.item_count;
  var cartInteger = parseInt(cartCount);

  if (cartInteger == 0) {
    $("#carto-sign").removeClass("cart-not-empty");
    $("#carto-sign").addClass("cart-empty");
    $(".cart-btno").addClass("hide");
    $("#side-checkout").addClass("cart-empty");
    $(".mobile-shipping").addClass("cart-empty");
    $(".cart-con .bar").addClass("cart-empty");
  } else {
    $(".cart-btno").removeClass("hide");
    $("#carto-sign").removeClass("cart-empty");
    $("#carto-sign").addClass("cart-not-empty");
    $("#side-checkout").removeClass("cart-empty");
    $(".mobile-shipping").removeClass("cart-empty");
    $(".cart-con .bar").removeClass("cart-empty");
  }
});


/*
let navBtn = document.querySelector("#nav-btn");
navBtn.addEventListener("click", function(e) {
  e.preventDefault();
  this.classList.toggle("open");
  document.querySelector("#mobile-nav-wrap").classList.toggle("open");
});

const menu = document.querySelector("nav");
const mobileMenu = document.querySelector("#mobile-nav-wrap");

mobileMenu.innerHTML = menu.innerHTML;

let mobileCartBtn = document.querySelector("#mobile-cart-btn");
let deskCartBtn = document.querySelector("#cart-icon");
mobileCartBtn.innerHTML = deskCartBtn.innerHTML;

let getAllParents = document.querySelectorAll(".has-child");

getAllParents.forEach(function(item, i) {
  let childControler = document.createElement("a");
  childControler.setAttribute("href", "#");
  childControler.setAttribute("class", "child-open-btn");
  item.appendChild(childControler);
  childControler.addEventListener("click", function(e) {
    e.preventDefault();
    item.querySelector("ul.child").classList.toggle("appear");
    childControler.classList.toggle("is-active");
  });
});
*/

window.addEventListener("load", function () {
  document.querySelector('body').classList.add('fully-loaded');
});

/*
  * Newsletter
*/
let newsBtns = document.querySelectorAll(".newsletter-btn");
let tempNewsPop = document.querySelector('.popup-newsletter');

newsBtns.forEach(function(item){
  item.addEventListener("click", function (event) {
    event.preventDefault();
    tempNewsPop.classList.toggle("active");
  });
});

let closeNews = document.querySelector(".popup-newsletter .close-news");
let newsWrapper = document.querySelector(".popup-newsletter");
    

closeNews.addEventListener("click", function (event) {
  event.preventDefault();
  newsWrapper.classList.remove("active");
  Cookies.set("news-cookie", "active", { expires: 7 });
});

setTimeout(function () {
  let newsCookie = Cookies.get("news-cookie");
  Cookies.set("news-cookie", "not-active");
  //console.log(newsCookie);
  if (newsCookie != "active") {
    newsWrapper.classList.add("active");
  }
}, 7000);

/*


Footer Newsletter


*/
var utils = utils || {};

utils.formValidEmail = function ($form) {
  var email = $form.find("input[type='email']").val();

  if (!email || !email.length) {
    return false;
  } else if (email.indexOf("@") == -1) {
    return false;
  }

  return true;
};

// subscribe form
$(".subscribe-form-footer").on("submit", function (event) {
  event.preventDefault();
  // console.log("Sub form");
  var _parent = $(this).parent().parent();

  if (!utils.formValidEmail($(this))) {
    var error = "A valid email address must be provided.";
    _parent.find(".subscribe-feedback p").html(error);
    _parent.find(".subscribe-add").stop(true, false).hide(0).delay(1500).fadeIn(2000);

    _parent.find(".subscribe-feedback").stop(true, false).show(0).delay(1500).hide(0);
  } else {
    //Moved this to top
    _parent.find(".subscribe-form").addClass("hide");
    _parent.find(".subscribe-feedback").addClass("show");
    _parent.find(".subscribe-feedback p").html("Subscribing...");

    _parent.find(".subscribe-feedback").stop(true, false).show(0);

    //_parent.find(".subscribe-add").hide();

    $.ajax({
      type: "GET",
      url: $(this).attr("action"),
      data: $(this).serialize(),
      cache: false,
      dataType: "jsonp",
      jsonp: "c", // trigger MailChimp to return a JSONP response
      contentType: "application/json; charset=utf-8",
      error: function (error) {},
      success: function (data) {
        if (data.result != "success") {
          var message = data.msg || "Sorry. Unable to subscribe. Please try again later.";

          if (data.msg && data.msg.indexOf("already subscribed") >= 0) {
            message = "You're already subscribed. Thank you.";
          }

          _parent.find(".subscribe-feedback p").html(message);
        } else {
          _parent.find(".subscribe-feedback p").html("Thank you.");
        }

        //_parent.find(".subscribe-add").stop(true, false).hide(0).delay(1500).fadeIn(2000);

        _parent.find(".subscribe-form").addClass("hide");

        _parent.find(".subscribe-feedback").stop(true, false).show(0).delay(1500).hide(0);

        _parent.find(".subscribe-feedback").stop(true, false).show(0).delay(1500);

        //_parent.find(".subscribe-add input").val("").hide(0);
      },
    });
  }
});

/*


Footer Newsletter


*/
var utilsTwo = utilsTwo || {};

utilsTwo.formValidEmail = function ($form) {
  var email = $form.find("input[type='email']").val();

  if (!email || !email.length) {
    return false;
  } else if (email.indexOf("@") == -1) {
    return false;
  }

  return true;
};

// subscribe form
$(".subscribe-form-pop").on("submit", function (event) {
  event.preventDefault();
  // console.log("Sub form");
  var _parent = $(this).parent().parent();

  if (!utilsTwo.formValidEmail($(this))) {
    var error = "A valid email address must be provided.";
    _parent.find(".subscribe-feedback p").html(error);
    _parent.find(".subscribe-add").stop(true, false).hide(0).delay(1500).fadeIn(2000);

    _parent.find(".subscribe-feedback").stop(true, false).show(0).delay(1500).hide(0);
  } else {
    //Moved this to top
    _parent.find(".subscribe-form").addClass("hide");
    _parent.find(".subscribe-feedback").addClass("show");
    _parent.find(".subscribe-feedback p").html("Subscribing...");

    _parent.find(".subscribe-feedback").stop(true, false).show(0);

    //_parent.find(".subscribe-add").hide();

    $.ajax({
      type: "GET",
      url: $(this).attr("action"),
      data: $(this).serialize(),
      cache: false,
      dataType: "jsonp",
      jsonp: "c", // trigger MailChimp to return a JSONP response
      contentType: "application/json; charset=utf-8",
      error: function (error) {},
      success: function (data) {
        if (data.result != "success") {
          var message = data.msg || "Sorry. Unable to subscribe. Please try again later.";

          if (data.msg && data.msg.indexOf("already subscribed") >= 0) {
            message = "You're already subscribed. Thank you.";
          }

          _parent.find(".subscribe-feedback p").html(message);
        } else {
          _parent.find(".subscribe-feedback p").html("Thank you.");
        }

        //_parent.find(".subscribe-add").stop(true, false).hide(0).delay(1500).fadeIn(2000);

        _parent.find(".subscribe-form").addClass("hide");

        _parent.find(".subscribe-feedback").stop(true, false).show(0).delay(1500).hide(0);

        _parent.find(".subscribe-feedback").stop(true, false).show(0).delay(1500);

        //_parent.find(".subscribe-add input").val("").hide(0);
      },
    });
  }
});
//
window.addEventListener("load", function () {
  let trueHeight = window.innerHeight;
  trueHeight = trueHeight - 50;
  let heightCons = this.document.querySelectorAll('.true-height');
  heightCons.forEach(function(item){
    item.style.height = trueHeight + "px";
  });
});

window.addEventListener("resize", function(){
  let trueHeight = window.innerHeight;
  trueHeight = trueHeight - 50;
  let heightCons = this.document.querySelectorAll('.true-height');
  heightCons.forEach(function(item){
    item.style.height = trueHeight + "px";
  });
});

//Books Button
let booksBtn = document.querySelector('#books-btn');
if(booksBtn){
  booksBtn.addEventListener("click", function (event) {
    event.preventDefault();
  });
}

//Contact Mobile
let contactBtn = document.querySelector('#contact-btn');
contactBtn.addEventListener('click', function(event){
  event.preventDefault();
  contactBtn.parentNode.classList.toggle('active');
})

//Shop Editions Button
let fakeBtns = document.querySelectorAll('.fake-btn');
fakeBtns.forEach(function(item){
  item.addEventListener("click", function (event) {
    event.preventDefault();
  });
});

//Mobile Nav v2
let barBottom = document.querySelectorAll('.nav-bar');
barBottom.forEach(function(item, i){
  let toggleBtn = item.querySelector('.toggle-btn');

  toggleBtn.addEventListener('click', function(event){
    event.preventDefault();
    toggleBars(i);
  });
});

let toggleBars = function(i){
  let barBottom = document.querySelectorAll('.nav-bar');
  barBottom.forEach(function(jtem, j){
    if(i != j){
      jtem.classList.remove('active');
    } else {
      jtem.classList.toggle('active');
    }
  });
}